import React from 'react';
import { Skeleton, SkeletonLine, Typography } from '@one-thd/sui-atomic-components';

import { useMessage } from '../../hooks/useMessage';
import { MESSAGE_KEY } from '../../utils/constants';

export const CardSelectProductLoader = () => {
  const text = useMessage(MESSAGE_KEY.cardCtaLoadingText);
  return (
    <div className="sui-pt-1">
      <Skeleton disablePadding disableGutters SkeletonContentProps={{ grow: true }}>
        <SkeletonLine variant="single" fullWidth />
        <div className="sui-py-8 sui-my-7">
          <Typography align="center" variant="body-base" color="subtle" weight="bold">
            {text}
          </Typography>
        </div>
        <SkeletonLine variant="single" fullWidth />
        <SkeletonLine variant="single" fullWidth />
        <SkeletonLine variant="single" fullWidth />
      </Skeleton>
    </div>
  );
};

CardSelectProductLoader.displayName = 'CardSelectProductLoader';

CardSelectProductLoader.propTypes = {};

CardSelectProductLoader.defaultProps = {};
